import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Tooltip } from "@mui/material";

interface Props {
    label?: string;
}

export default function ActivateDeactivateIndicator({ label }: Props) {
    return (
        <Tooltip
            arrow
            title={
                <Box display={"flex"} alignItems={"center"}>
                    {label ?? "Click an item to activate or deactivate it"}
                </Box>
            }
        >
            <HelpOutlineIcon />
        </Tooltip>
    );
}
